// extracted by mini-css-extract-plugin
export default {"container404":"_404_container404__JBKwj","textWrapper":"_404_textWrapper__CNOMv","link":"_404_link__8kBbP"};